import React from 'react';
import styled from 'styled-components';
import IconButton from '@components/dataEntry/button/IconButton';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import NotificationBtn from '@template/Notifications/NotificationBtn';
import { useRecoilValue } from 'recoil';
import { layoutDirState } from '@atom/setting/homepageSet';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import ChatBtn from '@pages/Chat/ChatBtn';
import { LAYOUT_DIR } from '@typings/setting/layoutDir';
import { useNavigate } from 'react-router-dom';
import LoginUserSec from './LoginUserSec';
import MainLogo from '../MainLogo';
import { LOGO_TYPE } from '@typings/setting/logoType';

const Box = styled.div`
  grid-area: info;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
  z-index: 4; // 1,2 안되고 3 이상이어야 유저 설정 드롭다운이 보입니다.

  @media (max-width: 480px) {
    display: none;
  }
`;

const BtnWrap = styled.div`
  display: flex;
`;
type Props = {
  style?: React.CSSProperties;
  showUser?: boolean;
  showTitle?: boolean;
};
function MiniNavBar({ style, showUser = true, showTitle = false }: Props) {
  const layoutDir = useRecoilValue(layoutDirState);
  const navigate = useNavigate();

  return (
    <Box style={{ ...style }}>
      <BtnWrap>
        <IconButton
          icon="Home20"
          shape="default"
          iconColor="var(--menuTextColor)"
          onClick={() => {
            navigate('/');
          }}
        />
        {showTitle && <MainLogo customLogoType={LOGO_TYPE.TEXT} />}
      </BtnWrap>

      <BtnWrap>
        <MusicButton color="var(--menuTextColor)" />
        <NotificationBtn
          dropdownDir={
            layoutDir === LAYOUT_DIR.LEFT ? 'bottomLeft' : 'bottomRight'
          }
          color="var(--menuTextColor)"
        />
        {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
        {showUser && <LoginUserSec dropdownDir={'rightBottom'} />}
      </BtnWrap>
    </Box>
  );
}

export default MiniNavBar;
